import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-fire-line"></i>
            <span>热门榜单</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频实时热门内容排行，看看大家都在追什么甜蜜好片
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href={item.url}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors group cursor-pointer"
            >
              <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg flex-shrink-0">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg md:text-xl font-bold font-heading ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                          ? 'text-accent-500'
                          : 'text-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-base font-semibold text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-1 text-xs text-foreground-500 flex-shrink-0">
                <i className="ri-eye-line text-xs"></i>
                <span className="whitespace-nowrap">{item.views}</span>
              </div>

              <div className="hidden sm:flex items-center text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}